<template>
	<div class="pagesContent">
				<el-card>
					<el-form ref="Search" :model="Search" label-width="100px" :rules="searchRules" inline>
						<el-form-item label="软件名称" prop="softwareId">
							<el-select v-model="Search.softwareId" size="small" @change="choseSoftware">
								<el-option v-for="(item,index) in softwareIdOptions" :key="index.id"
									:label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="版本类型">
							<el-select v-model="Search.versionTypeId" size="small" @change="choseVersiontype">
								<el-option v-for="(item,index) in versiontypeIdOptions" :key="index.Id"
									:label="item.Name" :value="item.Id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="版本号">
							<el-input v-model="version" size="small" @input="realInput" placeholder="版本号"></el-input>
						</el-form-item>
					</el-form>
				</el-card>

				<el-card style="margin-top:10px">
					<el-row class="header-title">
						<el-col :span="21">
							<h3>&nbsp;&nbsp;&nbsp;&nbsp;软件版本信息</h3>
						</el-col>
						<el-col :span="3">
							<el-button type="primary" size="medium" icon="el-icon-plus" @click="toReleaseVersion">发布新版本
							</el-button>
						</el-col>
					</el-row>
					<!-- 员工表格  条纹 stripe 边框 border -->
					<el-table highlight-current-row stripe size="mini" @sort-change='sortTableFun'
						:data="swVersionList" :row-class-name="tableRowClassName">
						<!-- 暂时不需要 可编辑功能（有需要随时加） @row-dblclick="exitRowVersion" -->
						<!-- <el-table-column prop="softwareId" label="软件编号" align="center" width="180"></el-table-column> -->
						<el-table-column prop="Software.Name" label="软件名称" min-width="70" align="center"></el-table-column>
						<el-table-column prop="Version" label="版本号" min-width="140" align="center"></el-table-column>
						<el-table-column prop="ReleaseTime" label="发布时间" min-width="100" align="center" sortable="custom">
							<template slot-scope="scope">
								{{scope.row.ReleaseTime | dateYMDFormat}}
							</template>
						</el-table-column>
						<el-table-column prop="ReleaseContent" label="发布内容" min-width="150" align="center">
							<template slot-scope="{row, $index}">
								<el-input type="textarea" placeholder="请输入发布内容" :autosize="{ minRows: 1, maxRows: 3}"
									v-model="row.ReleaseContent" v-if="editList[$index]">
								</el-input>
								<span v-else>{{row.ReleaseContent}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="DownloadURL" label="整包下载地址" min-width="150" align="center">
							<template slot-scope="{row, $index}">
								<el-input type="text" placeholder="整包下载地址" :autosize="{ minRows: 1, maxRows: 3}"
									v-model="row.DownloadURL" v-if="editList[$index]" disabled size="small"
									:title="row.DownloadURL">
									<el-button type="primary" slot="append" v-clipboard:copy="row.DownloadURL"
										v-clipboard:success="onCopy" v-clipboard:error="onError">
										复制
									</el-button>
								</el-input>
								<span v-else>{{row.DownloadURL}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="SqlDownloadURL" label="SQL语句下载地址" min-width="150" align="center">
						</el-table-column>
						<el-table-column prop="VersionTypeId" label="版本类型" min-width="70" align="center">
							<template slot-scope="{row, $index}">
								<el-select v-if="editList[$index]" v-model="row.VersionTypeId" placeholder="请选择版本类型">
									<!-- <el-option
                          v-for="item in versiontypeIdOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option> -->
								</el-select>
								<span v-else>{{row.SoftwareVersionType.Name}}</span>
							</template>
							<!-- <template slot-scope="{row, $index}">
                    <el-select v-if="editList[$index]" v-model="ReleaseVersion.VersionTypeId" placeholder="请选择版本类型">
                      <el-option label="稳定版" :value="1"></el-option>
                      <el-option label="测试版" :value="2"></el-option>
                    </el-select>
                    <span v-else>
                      <span v-if="row.VersionTypeId == 1">稳定版</span>
                      <span v-if="row.VersionTypeId == 2">测试版</span>
                    </span>
                </template> -->
						</el-table-column>
						<!-- 编辑状态才显示按钮 -->
						<el-table-column label="操作" align="center" v-if="exitSaveBtn">
							<template slot-scope="{row, $index}">
								<el-button size="mini" type="primary" v-if="editList[$index]" @click="exitSave(row)">保存
								</el-button>
								<el-button size="mini" type="danger" v-if="editList[$index]" @click="exitCancel(row)">取消
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" layout="prev, pager, next"
						:page-count="total">
					</el-pagination>
				</el-card>
			<!-- 单击 弹出框 frp -->
			<el-dialog title="发布新版本" :visible.sync="dialogReleaseVersion" width="45%" @close="onCloseAdd">
				<!-- :center="true"   居中 -->
				<div class="dialog-body">
					<el-form :model="ReleaseVersion" label-position="right" label-width="160px" autocomplete="off"
						ref="ReleaseVersion" :rules="releaseRules">
						<el-form-item label="软件" prop="SoftwareId">
							<el-col :span="14">
								<el-select v-model="ReleaseVersion.SoftwareId" placeholder="请选择软件"
									@change="changeSoftware">
									<el-option v-for="item in softwareIdOptions" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="SVN版本号" prop="VersionSVN">
							<el-col :span="14">
								<el-input v-model="VersionSVN" placeholder="请输入SVN版本号" @input="isVersionSVN"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="版本号" prop="Version">
							<el-col :span="14">
								<el-input v-model="ReleaseVersion.Version" placeholder="请输入版本号" :disabled="isDisabled">
								</el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="发布内容" prop="ReleaseContent">
							<el-col :span="14">
								<el-input v-model="ReleaseVersion.ReleaseContent" placeholder="请输入发布内容"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="整包下载地址" prop="downloadURL">
							<el-col :span="16">
								<el-input v-model="ReleaseVersion.downloadURL" placeholder="请输入整包下载地址"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="执行SQL语句下载地址">
							<el-col :span="16">
								<el-input v-model="ReleaseVersion.SqlDownloadURL" placeholder="请输入执行SQL语句下载地址">
								</el-input>
							</el-col>
						</el-form-item>
						<!-- 上传  zip  apk -->
						<!-- ReleaseVersion  action= "https://jsonplaceholder.typicode.com/posts/    http://desktop-vl3jsds:807/Software/Release/"   :data=""   accept=".apk, .zip"    :on-change="handleChange"   -->
						<!-- <el-form-item label="上传文件">
                  <el-col :span="14">  
                    <el-upload
                      class="upload-demo"
                      ref="uploadAPP"
                      action= ""
                      accept=".apk"
                      :data="ReleaseVersion"
                      :multiple="true"
                      :limit="limit"
                      :on-exceed="masterFileMax"
                      :auto-upload="false"
                      :on-change="fileChange1"
                      :on-remove="fileRemove1"
                      :file-list="Files1"
                      :http-request="httpRequest1"
                      v-model="Files1.length">
                        <el-button size="small" type="primary">选取应用程序文件</el-button>
                        <div slot="tip" class="el-upload__tip">仅限上传 apk 文件</div>
                    </el-upload>
                  </el-col>
                </el-form-item> -->
						<!-- 上传  zip  apk -->
						<!-- <el-form-item label="上传文件">
                  <el-col :span="14">
                    <el-upload
                      class="upload-demo"
                      ref="uploadSQL"
                      action= ""
                      accept=".zip"
                      :data="ReleaseVersion"
                      :multiple="true"
                      :limit="limit"
                      :on-exceed="masterFileMax"
                      :auto-upload="false"
                      :on-change="fileChange2"
                      :on-remove="fileRemove2"
                      :file-list="Files2"
                      :http-request="httpRequest2"
                      v-model="Files2.length">
                        <el-button size="small" type="primary">选取压缩文件</el-button>
                        <div slot="tip" class="el-upload__tip">仅限上传 zip 文件</div>
                    </el-upload>
                  </el-col>
                </el-form-item> -->
						<el-form-item label="版本类型" prop="VersionTypeId">
							<el-select v-model="ReleaseVersion.VersionTypeId" placeholder="请选择版本类型">
								<el-option v-for="item in versiontypeIdOptions" :key="item.Id" :label="item.Name"
									:value="item.Id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogReleaseVersion = false">取 消</el-button>
					<el-button type="primary" @click="confirmReleaseVersion('ReleaseVersion')">确 定</el-button>
				</div>
			</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 定时器
				time: null,
				// 版本号
				version: "",
				// 分页 当前页面
				currentPage: 1,
				// 总页数
				total: 1,
				//顶部搜索
				Search: {
					softwareId: '1', //软件名称 （ 默认：选工厂 ）
					versionTypeId: 1, // 版本类型（默认：不选）
				},
				//软件名称 ID 选项
				softwareIdOptions: [],
				//版本类型 ID 选项
				versiontypeIdOptions: [],
				//软件版本列表
				swVersionList: [],
				//软件版本备份列表
				swVersionListBackups: [],
				//索引列表
				editList: [],
				index: '',
				//编辑状态按钮
				exitSaveBtn: false,
				//添加版本类型  弹框
				dialogReleaseVersion: false,
				//是否禁用版本号输入框
				isDisabled: false,
				//是否改变软件
				isChangeSoftware: false,
				//SVN 输入框的值
				isSvn: '',
				//上传文件
				limit: 1,
				//SVN版本号
				VersionSVN: '',
				//发布版本 对象
				ReleaseVersion: {
					SoftwareId: 1, //软件编号
					Version: '', //版本号
					ReleaseContent: '', //发布内容
					VersionTypeId: 1, //版本类型  1稳定版  2测试版
					downloadURL: '', // 整包下载地址
					SqlDownloadURL: '' // 执行SQL语句下载地址
				},
				//表单验证规则 添加
				releaseRules: {
					SoftwareId: [{
						required: true,
						message: '请选择软件',
						trigger: 'change'
					}],
					Version: [{
						required: true,
						message: '请输入版本号',
						trigger: 'blur'
					}],
					VersionTypeId: [{
						required: true,
						message: '请选择版本类型',
						trigger: 'change'
					}],
					downloadURL: [{
						required: true,
						message: '请输入整包下载地址',
						trigger: 'blur'
					}]
				},
				//顶部表单筛选规则
				searchRules: {
					softwareId: [{
						required: true,
						message: '软件名称为必选项',
						trigger: 'change'
					}]
				},
				isDesc: true
			}
		},
		mounted() {
			//查询所有软件版本信息 表格
			this.getSoftwareVerAll()
			//查询所有软件
			this.getSoftwareInfoAll()
			//查询所有版本类型
			this.getVersiontypeAll()
		},
		methods: {
			// 根据发布时间排序
			sortTableFun(column) {
				// return console.log(column)
				this.column = column.prop;
				if (column.prop) {
					if (column.order == 'ascending') {
						this.isDesc = false;
					} else if (column.order == 'descending') {
						this.isDesc = true;
					}
					this.getSoftwareVerAll()
				}
			},
			// 版本号实时输入搜索
			realInput(val) {
				window.clearTimeout(this.time)
				this.time = setTimeout(() => {
					this.getSoftwareVerAll()
				}, 1000)
			},
			//监听顶部选择器改变事件
			choseSoftware(val) {
				// console.log(val)
				this.currentPage = 1
				this.getSoftwareVerAll()
			},
			choseVersiontype(val) {
				// console.log(val)
				this.currentPage = 1
				this.getSoftwareVerAll()
			},
			//搜索 重置
			searchReset(Search) {
				// console.log("========= 重置表单 ========")
				//重置表单
				this.$refs['Search'].resetFields()
				// console.log(this.Search)
				//备份版本信息 避免重新查询
				this.swVersionList = this.swVersionListBackups
			},
			//搜索 提交搜索
			searchSubmit(Search) {
				// console.log("========= 搜索数据 ========")
				//表单验证
				this.$refs[Search].validate((valid) => {
					if (valid) { //验证成功 返回 true 提交数据
						let search = '?softwareId=' + this.Search.softwareId + '&versionTypeId=' + this.Search
							.versionTypeId
						this.$http.getSoftwareVerAll(search).then(res => {
							if (res.status == 200) {
								this.swVersionList = res.data
								//每项按时间降序排序
								this.swVersionList.sort(function(a, b) {
									return b.ReleaseTime < a.ReleaseTime ? -1 : 1
								})
								// console.log(this.swVersionList)
							} else {
								this.$message.error({
									message: '条件查询失败！'
								})
							}
						})
					} else { //验证失败
						return false;
					}
				})
			},
			//选择文件 app
			fileChange1(file, fileList1) {
				// console.log("======== 选择文件 app ======")
				// console.log(file)
				this.fileList1 = fileList1
				console.log(this.fileList1)
			},
			fileRemove1(file, fileList1) {
				// console.log("======== 移除文件 app ======")
				this.fileList1 = fileList1
				// console.log(this.fileList1)
			},
			// 覆盖默认的上传行为,实现自定义上传 app
			httpRequest1(params) {
				// console.log(params)
				this.Files1.push(params
				.file); // 一般情况下是在这里创建FormData对象，但我们需要上传多个文件，为避免发送多次请求，因此在这里只进行文件的获取，param可以拿到文件上传的所有信息
				// console.log(this.Files1)
			},
			//覆盖默认的上传行为,实现自定义上传 sql
			httpRequest2(param) {
				// console.log(param)
				this.Files2.push(param.file);
				// console.log(this.Files2)
			},
			//确认发布 版本
			confirmReleaseVersion(ReleaseVersion) {
				// return console.log("确认 发布软件")
				//表单验证
				this.$refs[ReleaseVersion].validate((valid) => {
					if (valid) { //验证成功 返回true 提交数据
						var data = this.ReleaseVersion
						this.$http.addSoftwareVerSingle(data).then(res => {
							if (res.data.Code == 200) {
								//关闭弹框
								this.dialogReleaseVersion = false
								//提示
								this.$message.success({
									message: '添加成功！'
								})
								//查询所有软件版本信息
								this.getSoftwareVerAll() //或者：页面刷新 this.reload()

							} else { //Code 100  错误信息
								this.$message.error({
									message: res.data.MsgText
								})
							}
						})
					} else { //验证失败
						return false;
					}
				});

			},
			add() {

			},
			//弹窗关闭时重置表单
			onCloseAdd() {
				this.$refs['ReleaseVersion'].resetFields()
				//解除版本号 input 的禁用
				this.isDisabled = false
				//数据 恢复默认
				this.VersionSVN = '' //SVN版本号
			},
			//添加版本 改变选择的软件
			changeSoftware(val) {
				// console.log(val)
				// console.log(this.isSvn)
				if (this.isSvn != '' && this.isSvn != null && this.isSvn != undefined && this.isSvn !=
					'undefined') { //SVN 输入框有值，
					//重新生成版本号（规则：年.月.日.软件编号和SVN）
					var date = new Date()
					var y = date.getFullYear();
					var year = y.toString().substring(2) //数字转字符串再截取
					var month = date.getMonth() + 1;
					var day = date.getDate();
					var softwareId = this.ReleaseVersion.SoftwareId
					// console.log("软件编号为：" + softwareId)
					var VersNum = year + '.' + month + '.' + day + '.' + softwareId + this.isSvn
					// console.log(VersNum)
					this.ReleaseVersion.Version = VersNum
				} else { //SVN 输入框为 'undefined' 或者 空 ''
					// console.log("不 存在SVN")
					this.isDisabled = false //解除 input 禁用
					this.ReleaseVersion.Version = '' //清空 input 内容
				}
			},
			//判断SVN版本号是否为空（控制版本号是否禁用）
			isVersionSVN(val) {
				// console.log(val)
				this.isSvn = val
				if (this.isSvn != '' && this.isSvn != null && this.isSvn != undefined) { //SVN 输入框有值，
					this.isDisabled = true //控制是否禁用版本号输入框
					// console.log("存在SVN：" + this.isDisabled)
					//生成版本号（规则：年.月.日.软件编号和SVN）
					var date = new Date()
					var y = date.getFullYear();
					var year = y.toString().substring(2) //数字转字符串再截取
					var month = date.getMonth() + 1;
					var day = date.getDate();
					var softwareId = this.ReleaseVersion.SoftwareId
					// console.log("软件编号为：" + softwareId)
					var VersNum = year + '.' + month + '.' + day + '.' + softwareId + this.isSvn
					// console.log(VersNum)
					this.ReleaseVersion.Version = VersNum
				} else { //SVN 输入框为空
					// console.log("不 存在SVN：" + this.isDisabled)
					this.isDisabled = false //解除 input 禁用
					this.ReleaseVersion.Version = '' //清空 input 内容
				}
			},

			// console.log("============================================")

			//查询所有软件版本信息
			getSoftwareVerAll() {
				let aaa =
					`?pageIndex=${ this.currentPage }&softwareId=${this.Search.softwareId}&version=${this.version}&versionTypeId=${ this.Search.versionTypeId}&isDesc=${this.isDesc}` // 未防止访问接口类型错误
				// let aaa = `?pageIndex=${ this.currentPage }&softwareId=${this.Search.softwareId}&version=${}&versionTypeId=${}&isDesc=${true}`		// 未防止访问接口类型错误
				this.$http.getSoftwareVerAll(aaa).then(res => {
					// return console.log(res,'3');
					if (res.status == 200) {
						// const sjclarr = res.data.Items.map((i)=>{
						// 				if(i.customerRealName==null){
						// 					 i.customerRealName=''
						// 				}else{
						// 					 i.customerRealName=i.customerRealName.split('（')[0]
						// 					 console.log(i.customerRealName)
						// 				}
						// 				return i
						// 			})
						// this.swVersionList = sjclarr
						this.swVersionList = res.data.Items
						this.total = res.data.TotalPages
						//每项按时间降序排序
						// this.swVersionList.sort(function(a, b) {
						//   return b.ReleaseTime < a.ReleaseTime ? -1 : 1
						// })


						// console.log(this.swVersionList)
						// 备份列表  避免重复查询
						this.swVersionListBackups = this.swVersionList
					} else {
						this.$message.error({
							message: '查询软件版本信息失败！'
						})
					}
				})
			},
			//发布新版本
			toReleaseVersion() {
				// console.log("点击了 发布新版本")
				this.dialogReleaseVersion = true
			},
			//查询所有软件信息
			getSoftwareInfoAll() {
				this.$http.getSoftwareInfoAll().then(res => {
					// return console.log(res,'2')
					if (res.status == 200) {
						var softwareInfoData = res.data
						// console.log(softwareInfoData)
						//遍历数据 构造版本类型新数组
						for (var i = 0; i < softwareInfoData.length; i++) {
							// console.log(i)
							var soft = {
								id: softwareInfoData[i].Id,
								name: softwareInfoData[i].Name
							}
							this.softwareIdOptions.push(soft)
						}
						// console.log(this.softwareIdOptions)
						//默认选中第一项
						this.ReleaseVersion.SoftwareId = this.softwareIdOptions[0].id

					} else {
						this.$message.error({
							message: '查询软件信息失败！'
						})
					}
				})
			},
			//查询所有版本类型信息
			getVersiontypeAll() {
				this.$http.getVersiontypeAll().then(res => {
					// return console.log(res,'1')
					// return console.log(res)
					if (res.status == 200) {
						this.versiontypeIdOptions = res.data
					} else {
						this.$message.error({
							message: '查询版本类型信息失败！'
						})
					}
				})
			},
			//获取 table 索引
			tableRowClassName({
				row,
				rowIndex
			}) {
				// console.log(row)
				// console.log(rowIndex)
				//把每一行的索引放进row
				row.index = rowIndex
				//赋值本页面
				this.index = rowIndex
			},
			//编辑 保存
			exitSave(row) {
				// console.log(row)
				var index = row.index
				//关闭编辑状态
				this.editList[index] = false;
				this.$set(this.editList, index, false); //this.$set （要更改的数据源(可以是对象或者数组) ，要更改的具体数据，重新赋的值）
				//隐藏 按钮
				this.exitSaveBtn = false
			},
			//编辑 取消
			exitCancel(row) {
				var index = row.index
				//关闭编辑状态
				this.editList[index] = false;
				this.$set(this.editList, index, false); //this.$set （要更改的数据源(可以是对象或者数组) ，要更改的具体数据，重新赋的值）
				//隐藏 按钮
				this.exitSaveBtn = false
				//如若修改，还原数据
				// console.log(localStorage.getItem('versionInfoRow'))
				var versionInfoRow = JSON.parse(localStorage.getItem('versionInfoRow'))
				// console.log(versionInfoRow)
				this.swVersionList[index] = versionInfoRow
				// console.log(this.swVersionList[index])
			},
			//双击 编辑行版本信息
			exitRowVersion(row) {
				// console.log("双击")
				// console.log(row)
				var index = row.index
				//存入缓存 保存修改前原始数据 供"取消"按钮使用
				// console.log("============  缓存  ============")
				var row = JSON.stringify(this.swVersionList[index])
				localStorage.setItem('versionInfoRow', row)
				// console.log(localStorage.getItem('versionInfoRow'))

				// 取出 swVersionList 表格数据，赋值给新数组 editList
				this.editList = new Array(this.swVersionList.length);
				//根据 index 设置该行可以编辑
				this.editList[index] = true;
				this.$set(this.editList, index, true); //this.$set （要更改的数据源(可以是对象或者数组) ，要更改的具体数据，重新赋的值）
				//显示 按钮
				this.exitSaveBtn = true
			},
			//复制回调 成功
			onCopy(e) {
				this.$message({
					message: '复制成功！',
					type: 'success'
				})
			},
			//复制回调 失败
			onError(e) {
				this.$message({
					message: '复制失败！',
					type: 'error'
				})
			},
			handleCurrentChange(e) {
				this.currentPage = e
				this.getSoftwareVerAll()
			}
		}
	}
</script>

<style>
	.pagesContent {
		width: 100%;
		height: 100%;
	}

	.header-title {
		margin: 10px 0 20px;
	}

	/* 对话框 */
	.dialog-body {
		padding: 0 40px 0 100px;
	}
</style>
